import { render, staticRenderFns } from "./DosimetrieItem.vue?vue&type=template&id=1029232e&"
import script from "./DosimetrieItem.vue?vue&type=script&lang=js&"
export * from "./DosimetrieItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports